import _ from 'lodash';
import DepsService from 'services/dependencies';
import { checkAccess } from 'app/actions/app.actions';

function generateMenu(menuData = {}, parameters = {}) {
  const { config } = DepsService.$ngRedux.getState();
  const { gameImagesEditable } = config;
  const numericAscendingCompareFn = (a, b) => a - b;
  return Object.keys(menuData)
    .sort(numericAscendingCompareFn)
    .map((key) => {
      let item = _.cloneDeep(menuData[key]);
      const label = _.get(item, `label`) || DepsService.gettextCatalog.getString('MISSING_MENU_ITEM_TRANSLATION');
      item = _.flow([
        (item) => _.set(item, 'label', label),
        (item) => {
          if (item.sref === 'cms-gameImages' && !gameImagesEditable) {
            return _.set(item, 'hasAccess', false);
          }

          return _.set(item, 'hasAccess', DepsService.$ngRedux.dispatch(checkAccess(item.sref)));
        },
      ])(item);
      return _.merge(
        {
          index: key,
        },
        _.merge(item, parameters[item.id], {})
      );
    });
}

function generateTopMenu(menuData = {}) {
  return Object.keys(menuData).reduce((reduced, index) => {
    const item = _.cloneDeep(menuData[index]);
    item.label = item.label || '';
    item.title = item.title ? item.title : undefined;
    item.hasAccess = DepsService.$ngRedux.dispatch(checkAccess(item.sref));
    reduced[item.id] = item;
    return reduced;
  }, {});
}

export default {
  generateMenu,
  generateTopMenu,
};



// WEBPACK FOOTER //
// ./src/modules/auth/helpers/menu.js